import type { Router } from "vue-router";
import type { Pinia } from "pinia";
import { VueNavigationClient } from "./helpers";
import { ensureAuth } from "./authGuard";
import { useEnvironmentFlags } from "@/core/composables/useEnvironmentFlags";
import { useAuthToken } from "@/core/composables/useAuthToken";
import { useAppContextStore } from "@/core/store";
import { mockUser } from "@/core/store/mock/mock.user";

export function setupRouterGuards(router: Router, pinia: Pinia): void {
  const client = new VueNavigationClient(router);

  const { useMsal } = useEnvironmentFlags();
  const { hasValidToken, clearToken, syncFromStorage } = useAuthToken();

  router.beforeEach(async (to) => {
    syncFromStorage();

    if (!useMsal.value) {
      if (to.meta?.requiresAuth === false) return true;

      if (!hasValidToken.value) {
        clearToken();
        return { path: "/login", query: { redirect: to.fullPath } };
      }

      const appContext = useAppContextStore(pinia); // active pinia

      const page = (appContext.context.user as any)?.permissions?.page ?? {};
      const hasPermissions = Object.keys(page).length > 0;

      if (!hasPermissions) {
        await mockUser.load(); // this should update AppContextStore
      }

      return true;
    }

    return await ensureAuth(to, client);
  });
}
